import { render, staticRenderFns } from "./mallCouponUseLog.vue?vue&type=template&id=490ccc2b"
import script from "./mallCouponUseLog.vue?vue&type=script&lang=js"
export * from "./mallCouponUseLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports